module.exports = __webpack_public_path__ + "img/result_logo_inicial.5cac0b6a.png";